import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { InfoPanelTypes } from '..';

import { InfoPanelVisibleDesktop } from './Desktop';
import { InfoPanelVisibleMobile } from './Mobile';
import { InfoPanelVisibleTablet } from './Tablet';

export const InfoPanelVisible: React.FC<
  InfoPanelTypes.Props & { onToggleAccordion: () => void }
> = ({ onToggleAccordion, ...props }) => {
  const responsiveComponent = useBreakpointValue({
    base: <InfoPanelVisibleMobile onToggleAccordion={onToggleAccordion} {...props} />,
    sm: <InfoPanelVisibleTablet {...props} />,
    lg: <InfoPanelVisibleDesktop {...props} />,
  });

  return responsiveComponent;
};
